import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

/**
 * User Effects
 *
 * This file previously contained effects for loading user data via verifysession API.
 * Now that we've migrated to V2 authentication with HttpOnly cookies,
 * user data is loaded via initializeSession in auth.effects.ts.
 *
 * This file is kept for potential future user-related side effects.
 */
@Injectable()
export class UserEffects {
	constructor(private actions$: Actions) {}
}
